import { Fade } from "react-reveal";
import CTA from "../../components/CTA/CTA";
import Footer from "../../components/Footer/Footer";
import Hero from "./Hero/Hero";
import "./Pricing.css";

const Pricing = () => {
  return (
    <div>
      <Fade duration={250}>
        <Hero />
      </Fade>
      <Footer />
    </div>
  );
};

export default Pricing;
